/**
 * Can only be a single sendbird connection in the application,
 * so not a UI/setContext pattern
 */
import { BehaviorSubject, mergeMap, Observable, of, shareReplay, switchMap } from "rxjs";
import SendBird, {} from "sendbird";
const sendbirdUserInfo$ = new BehaviorSubject(null);
export function setUserInfo(id, name) {
    sendbirdUserInfo$.next({ id, name });
}
export function clearUserInfo() {
    sendbirdUserInfo$.next(null);
}
const sendbird$ = sendbirdUserInfo$.pipe(switchMap(data => {
    if (data) {
        const { id, name } = data;
        return new Observable(subscriber => {
            const sendBird = new SendBird({ appId: 'A6F8A6E6-04CA-42EB-9E49-15DE23873DD4', localCacheEnabled: false });
            sendBird.connect(id, (usr, error) => {
                if (error) {
                    subscriber.error(error);
                    return;
                }
                sendBird.updateCurrentUserInfo(name, '', () => { });
                subscriber.next(sendBird);
            });
        });
    }
    else {
        return of(null);
    }
}), shareReplay({ bufferSize: 1, refCount: true }));
/**
 * Will emit null if the connection stops
 */
export function getChannel(url) {
    return sendbird$.pipe(mergeMap(sendbird => {
        if (!sendbird)
            return of(null);
        else {
            return new Observable(subscriber => {
                let lChannel;
                sendbird.OpenChannel.getChannel(url, (channel, error) => {
                    if (error) {
                        subscriber.error(error);
                        return;
                    }
                    lChannel = channel;
                    channel.enter((response, error) => {
                        if (error) {
                            subscriber.error(error);
                            return;
                        }
                        subscriber.next({ channel, sendbird });
                    });
                });
                return () => lChannel === null || lChannel === void 0 ? void 0 : lChannel.exit();
            });
        }
    }));
}
